<div class="grid-12 container">

    <h1 class="text-primary-dark">Plan actual</h1>
    <div class="alert alert-bg-warning" role="alert" (click)="removeAlert($event)">
        <span class="ico-close" data-close="close"></span>
        <strong class="alert__title">¡Ten en cuenta!</strong> Para comprar servicios adicionales o hacer uso de ellos debes tener al menos un inmueble activo en Ciencuadras.
    </div>
    <div *ngIf="activePlan != undefined">
        <div class="alert bg-grayscale-white-2 notification" role="alert" (click)="removeAlert($event)" *ngIf="activePlan.remainingDays == 0">
            <div class="line"></div>
            <div class="icon_notification"></div>
            <span class="ico-close icon-close" data-close="close"></span>
            <p class="message_notification"><strong class="alert__title_notification">Tu plan ha caducado, ¡es hora de actualizarlo!</strong> Descubre nuestros planes mejorados y actualiza tu plan</p>
        </div>
    </div>
    <div class="mat-expansion-panel--blue" *ngIf=" activePlan != undefined">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>mis productos</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content px-mid py-mid grid">
                <div class="grid-12 grid-md-4 grid-lg-4">
                    <div class="item item--main d-flex jc-space-between pb-base" *ngIf=" activePlan.id != null || activePlan.id != undefined">
                        <div>
                            <h3 class="mb-xsmall mt-none text-small">{{activePlan.namePlan}}</h3>
                            <button class="button secondary rounded px-mid py-tiny text-xsmall" type="button" (click)="onClickPayPlan()" *ngIf="userType === 4">Pagar
                                plan</button>
                        </div>
                        <div>
                            <p class="item__quantity mb-tiny">{{activePlan.remainingDays}}<span class="available">Días Disponibles</span></p>
                            <p class="item__time text-xsmall">Vence: <time class="date-time text-small" datetime="05-18-2021">{{activePlan.dateEnd.substring(0,10)}}</time></p>
                        </div>
                    </div>

                    <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall pt-small">
                        <span class="item__icon material-icons">upgrade</span>
                        <p class="item__description">INMUEBLES ASCENDIDOS</p>
                        <p class="item__quantity">{{ascendidos}}<span class="available">Disponibles</span></p>
                    </div>
                </div>
                <div class="grid-12 grid-md-4 grid-lg-4 pt-mid mt-tiny mp-o">
                    <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                        <span class="item__icon material-icons">camera_alt</span>
                        <p class="item__description">FOTOS 360 + TOUR VIRTUAL</p>
                        <p class="item__quantity">{{foto36}}<span class="available">Disponibles</span></p>
                    </div>
                    <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                        <span class="item__icon material-icons">3d_rotation</span>
                        <p class="item__description">RECORRIDO 3D</p>
                        <p class="item__quantity">{{recorrido3d}}<span class="available">Disponible</span></p>
                    </div>
                </div>
                <div class="grid-12 grid-md-4 grid-lg-4 pt-mid mt-tiny mp-o">
                    <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                        <span class="item__icon material-icons">star_outline</span>
                        <p class="item__description">INMUEBLES DESTACADOS</p>
                        <p class="item__quantity">{{destacados}}<span class="available">Disponibles</span></p>
                    </div>
                    <div class="item d-flex jc-space-between px-tiny pb-xsmall mb-xsmall">
                        <span class="item__icon material-icons">monetization_on</span>
                        <p class="item__description">PRECIO DE REFERENCIA</p>
                        <p class="item__quantity">{{precioenlinea}}<span class="available">Disponibles</span></p>
                    </div>
                </div>
            </div>
            <div class="panel-footer p-medium text-center" *ngIf="activePlan.id != null || activePlan.id != undefined">
                <button class="button bg-grayscale-gray-1 text-grayscale-base rounded text-small" type="button" (click)='actualizarPlan()'>Actualizar Plan</button>
            </div>
        </mat-expansion-panel>
    </div>
</div>

<h1 class="text-primary-dark container">Comprar productos</h1>
<div class="grid container counter-box bg-grayscale-white mt-mid mb-medium">
    <div class="grid-12 grid-md-10 grid-start-md-2 grid-lg-8 grid-start-lg-3">
        <div class="product-box product-box--dash">
            <h3 class="title-three">
                <span class="item__icon material-icons text-grayscale-white mr-tiny">monetization_on</span> Conoce el poder de un lead perfilado</h3>
            <p class="title-three-description pb-medium text-grayscale-gray-5 d-none d-md-block d-lg-block">¡Potencia tus resultados con leads que marcan la diferencia!</p>

            <div class="grid product-card-box">
                <ng-container *ngFor="let item of products; index as i">
                    <app-product-card class="grid-12 grid-sm-6" *ngIf="item.prodCategory  === 3" [productData]='item' [dataIndex]='i'>
                    </app-product-card>
                </ng-container>
            </div>
        </div>
        <div class="product-box product-box--dash">
            <h3 class="title-three text-grayscale-gray-6">
                <span class="item__icon material-icons text-grayscale-white mr-tiny">camera_alt</span> Tour por tus inmuebles</h3>
            <p class="title-three-description pb-medium text-grayscale-gray-5 d-none d-md-block d-lg-block">¡Todo entra por los ojos! Mueve más rápido tus propiedades con estas herramientas de visualización.</p>

            <div class="grid product-card-box">
                <ng-container *ngFor="let item of products; index as i">
                    <app-product-card class="grid-12 grid-sm-6" *ngIf="item.prodCategory  === 1" [productData]='item' [dataIndex]='i'>
                    </app-product-card>
                </ng-container>
            </div>
        </div>
        <div class="product-box product-box--dash">
            <h3 class="title-three">
                <span class="item__icon material-icons text-grayscale-white mr-tiny">star_outline</span> Relevancia para tus publicaciones</h3>
            <p class="title-three-description pb-medium text-grayscale-gray-5 d-none d-md-block d-lg-block">Dicen que “el que pega primero pega dos veces”, que tus inmuebles sean los primeros en verse.</p>

            <div class="grid product-card-box">
                <ng-container *ngFor="let item of products; index as i">
                    <app-product-card class="grid-12 grid-sm-6" *ngIf="item.prodCategory  === 2" [productData]='item' [dataIndex]='i'>
                    </app-product-card>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="text-center pt-base pb-base btn-produc grid-12">
        <div class="shopping-container px-base py-tiny d-block">
            <div class="shopping-bar d-flex jc-space-between ai-center px-tiny">
                <span class="shopping-bar__value">{{count}}</span>
                <button class="shopping-bar__button py-xsmall text-small ai-center d-inline-flex" type="button" (click)="openShoppingDialog()">Comprar Productos </button>
                <span class="shopping-bar__price">${{summary.toLocaleString()}}</span>
            </div>
        </div>
    </div>
</div>